import CryptoJS from 'crypto-js';

const secretKey = process.env.REACT_APP_GW3_SECRET_KEY;

const shortenBase64 = (base64) => {
  return base64
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
};

const expandShortened = (shortened) => {
  const base64 = shortened
    .replace(/-/g, '+')
    .replace(/_/g, '/');
  const padding = '='.repeat((4 - base64.length % 4) % 4);
  return base64 + padding;
};

export const encrypt = (value) => {
  const encrypted = CryptoJS.AES.encrypt(value, secretKey).toString();
  return shortenBase64(encrypted);
};

export const decrypt = (encryptedValue) => {
  const fullBase64 = expandShortened(encryptedValue);
  const decrypted = CryptoJS.AES.decrypt(fullBase64, secretKey);
  return decrypted.toString(CryptoJS.enc.Utf8);
};

export function generate_signature(raw, signKey) {
  const formattedBody = JSON.stringify(raw, null, 0);

  const hash = CryptoJS.HmacSHA256(formattedBody, signKey);
  const signature = CryptoJS.enc.Hex.stringify(hash)
  return signature;
}
